import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import { Routes, UserRolesCode } from '@enums';
import { i18n } from '@localization';

var AccessServiceClass = /*#__PURE__*/function () {
  function AccessServiceClass() {
    _classCallCheck(this, AccessServiceClass);
  }

  _createClass(AccessServiceClass, [{
    key: "getRouteAccessConfig",
    value: function getRouteAccessConfig(route) {
      switch (route) {
        case Routes.Main:
        case Routes.All:
        case Routes.Users:
          {
            return {
              roles: [UserRolesCode.ADMIN]
            };
          }

        default:
          {
            return {};
          }
      }
    }
  }, {
    key: "accessToRoute",
    value: function accessToRoute(route, user) {
      var _user$roles, _user$roles2;

      var _this$getRouteAccessC = this.getRouteAccessConfig(route),
          roles = _this$getRouteAccessC.roles,
          rolesCombinations = _this$getRouteAccessC.rolesCombinations;

      var userHaveAccessToRoute = false;

      if (roles !== null && roles !== void 0 && roles.length && user !== null && user !== void 0 && (_user$roles = user.roles) !== null && _user$roles !== void 0 && _user$roles.length) {
        userHaveAccessToRoute = !!(roles !== null && roles !== void 0 && roles.find(function (role) {
          return user.roles.includes(role);
        }));
      } else if (rolesCombinations !== null && rolesCombinations !== void 0 && rolesCombinations.length && user !== null && user !== void 0 && (_user$roles2 = user.roles) !== null && _user$roles2 !== void 0 && _user$roles2.length) {
        for (var combinationIndex = 0; combinationIndex < rolesCombinations.length; combinationIndex += 1) {
          var combinationItem = rolesCombinations[combinationIndex];

          if (combinationItem !== null && combinationItem !== void 0 && combinationItem.length) {
            var a = _toConsumableArray(combinationItem);

            var b = _toConsumableArray(user.roles);

            if (a.sort().join(',') === b.sort().join(',')) {
              userHaveAccessToRoute = true;
              break;
            }
          }
        }
      }

      return userHaveAccessToRoute;
    }
  }, {
    key: "getAvailableMenuItems",
    value: function getAvailableMenuItems(user) {
      var _this = this;

      var itemsToRoutes = [{
        label: i18n.t('components.header.menuItems.trade'),
        icon: '',
        route: Routes.Users
      }];
      return itemsToRoutes.filter(function (menuItem) {
        return _this.accessToRoute(menuItem.route, user);
      });
    }
  }, {
    key: "getHomeRoute",
    value: function getHomeRoute(user) {
      var menuItems = this.getAvailableMenuItems(user);

      for (var menuItemIndex = 0; menuItemIndex < menuItems.length; menuItemIndex += 1) {
        var menuItem = menuItems[menuItemIndex];

        if (this.accessToRoute(menuItem.route, user)) {
          return menuItem.route;
        }
      }

      return Routes.NotFound;
    }
  }]);

  return AccessServiceClass;
}();

var AccessService = new AccessServiceClass();
export { AccessService };